import { useEffect } from 'react';

/**
 * ConfettiEffect - Creates a celebratory confetti animation
 * 
 * @param {boolean} trigger - When true, triggers the confetti effect
 * @param {function} onComplete - Callback when animation completes
 */
const ConfettiEffect = ({ trigger, onComplete }) => {
  useEffect(() => {
    if (!trigger) return undefined;

    // Simple confetti implementation using DOM elements
    const duration = 3000;
    const animationEnd = Date.now() + duration;

    function randomInRange(min, max) {
      return Math.random() * (max - min) + min;
    }

    function createConfettiParticle() {
      const colors = [
        "#26ccff",
        "#a25afd",
        "#ff5e7e",
        "#88ff5a",
        "#fcff42",
        "#ffa62d",
        "#ff36ff",
      ];

      const particle = document.createElement("div");
      const color = colors[Math.floor(Math.random() * colors.length)];
      const size = randomInRange(8, 12);
      const startX = randomInRange(0, window.innerWidth);
      const startY = -20;
      const endY = window.innerHeight + 20;
      const particleDuration = randomInRange(2000, 4000);
      const rotation = randomInRange(0, 360);
      const drift = randomInRange(-100, 100);

      particle.style.position = "fixed";
      particle.style.width = `${size}px`;
      particle.style.height = `${size}px`;
      particle.style.backgroundColor = color;
      particle.style.left = `${startX}px`;
      particle.style.top = `${startY}px`;
      particle.style.borderRadius = "50%";
      particle.style.pointerEvents = "none";
      particle.style.zIndex = "9999";
      particle.style.opacity = "1";

      document.body.appendChild(particle);

      // Animate the particle
      const animation = particle.animate(
        [
          {
            transform: `translate(0, 0) rotate(0deg)`,
            opacity: 1,
          },
          {
            transform: `translate(${drift}px, ${endY - startY}px) rotate(${rotation}deg)`,
            opacity: 0,
          },
        ],
        {
          duration: particleDuration,
          easing: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
        }
      );

      animation.onfinish = () => {
        particle.remove();
      };
    }

    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        clearInterval(interval);
        if (onComplete) onComplete();
        return;
      }

      const particleCount = 50 * (timeLeft / duration);

      // Create confetti particles
      for (let i = 0; i < particleCount; i += 1) {
        createConfettiParticle();
      }
    }, 250);

    return () => {
      clearInterval(interval);
    };
  }, [trigger, onComplete]);

  return null;
};

export default ConfettiEffect;

